import { Component, Input } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { provideTranslocoScope, TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "cerrix-loader",
    templateUrl: "./cerrix-loader.component.html",
    styleUrls: ["./cerrix-loader.component.scss"],
    providers: [
        provideTranslocoScope({ scope: "shared/components/cerrix-loader", alias: "cerrixLoader" })
    ],
    imports: [TranslocoPipe]
})
export class CerrixLoaderComponent {
    @Input() cerrixTab: TabModel;
    @Input() showLoader = false;
    @Input() customMessage: string = "";
}
